import React, { Component } from 'react';
import './styles.css';
import PropTypes from 'prop-types';
import { MultiYearScalarType } from '../../types';
import ThreeYearsTableLayout from '../ThreeYearsTableLayout';
import OutputNumberUnit from '../OutputNumberUnit';
import InputNumberUnit from '../InputNumberUnit';
import BusinessPlanSubSectionTitle from '../BusinessPlanSubSectionTitle';
import { FormattedHTMLMessage } from 'react-intl';
import range from 'lodash/range';
import LabelDescription from '../LabelDescription';

class ProductionInternally extends Component {
	render() {
		const { Header, Row, Col, Label } = ThreeYearsTableLayout;
		const { game } = this.props;
		const { viewMode } = game;
		const {
			machineProductionCapacity,
			machines,
			totalProductionCapacityAtFullUsage,
			machineProductionCapacityUsageQuota,
			machineProductionCapacityUsage
		} = game.production;

		return (
			<div className="production-program">
				<BusinessPlanSubSectionTitle label={'production-internally-title'} />
				<ThreeYearsTableLayout>
					<Header />
					<Row>
						<Label>
							<FormattedHTMLMessage id={'production-capacity-per-line'} />
						</Label>
						{range(1, 4).map(n => (
							<Col key={n}>
								<OutputNumberUnit
									unit={'u'}
									variable={machineProductionCapacity[n - 1]}
								/>
							</Col>
						))}
					</Row>
					<Row>
						<Label>
							<LabelDescription
								label={'number-production-lines'}
								description={'number-production-lines-desc'}
							/>
						</Label>
						<Col>
							<InputNumberUnit
								active={!viewMode}
								unit={'LINES'}
								variable={machines}
							/>
						</Col>
						<Col />
						<Col />
					</Row>
					<Row>
						<Label>
							<FormattedHTMLMessage id={'total-production-capacity'} />
						</Label>
						{range(1, 4).map(n => (
							<Col key={n}>
								<OutputNumberUnit
									unit={'u'}
									variable={totalProductionCapacityAtFullUsage[n - 1]}
								/>
							</Col>
						))}
					</Row>
					<Row>
						<Label>
							<FormattedHTMLMessage id={'production-line-capacity-usage'} />
						</Label>
						{range(1, 4).map(n => (
							<Col key={n}>
								<InputNumberUnit
									active={!viewMode}
									unit={'%'}
									max={100}
									variable={machineProductionCapacityUsageQuota[n - 1]}
								/>
							</Col>
						))}
					</Row>
					<Row>
						<Label>
							<FormattedHTMLMessage id={'units-to-be-produced-internally-CD'} />
						</Label>
						{range(1, 4).map(n => (
							<Col key={n}>
								<OutputNumberUnit
									unit={'u'}
									variable={machineProductionCapacityUsage[n - 1]}
								/>
							</Col>
						))}
					</Row>
				</ThreeYearsTableLayout>
			</div>
		);
	}
}

ProductionInternally.propTypes = {
	game: PropTypes.shape({
		id: PropTypes.string.isRequired,
		viewMode: PropTypes.bool,
		production: PropTypes.shape({
			machineProductionCapacity: MultiYearScalarType,
			machines: PropTypes.object,
			totalProductionCapacityAtFullUsage: MultiYearScalarType,
			machineProductionCapacityUsageQuota: MultiYearScalarType,
			machineProductionCapacityUsage: MultiYearScalarType
		})
	})
};

export default ProductionInternally;
